import * as React from 'react';

export default (props:any) => (
    <svg
        viewBox='0 0 24 24'
        {...props}
    >
        <g
            fill='none'
            fillRule='evenodd'
        >
            <circle
                cx='12'
                cy='12'
                r='11.5'
                fill='#FFF'
            />
            <path
                fill='#000'
                fillOpacity='.54'
                d='M12 0C5.372 0 0 5.508 0 12.305c0 5.435 3.438 10.047 8.207 11.674.6.113.82-.267.82-.593 0-.292-.011-1.066-.017-2.093-3.338.744-4.043-1.65-4.043-1.65-.545-1.42-1.332-1.798-1.332-1.798-1.09-.764.083-.749.083-.749 1.204.087 1.837 1.268 1.837 1.268 1.071 1.88 2.809 1.338 3.493 1.022.109-.795.42-1.337.762-1.645-2.665-.31-5.466-1.365-5.466-6.08 0-1.343.467-2.442 1.235-3.302-.123-.311-.535-1.562.117-3.256 0 0 1.008-.33 3.3 1.261.958-.273 1.984-.409 3.005-.414 1.019.005 2.046.141 3.004.414 2.29-1.592 3.296-1.261 3.296-1.261.655 1.694.244 2.945.12 3.256.77.86 1.233 1.959 1.233 3.302 0 4.726-2.805 5.767-5.478 6.071.43.38.814 1.13.814 2.279 0 1.645-.015 2.971-.015 3.375 0 .329.216.712.825.591 4.765-1.63 8.2-6.239 8.2-11.672C24 5.508 18.627 0 12 0'
            />
        </g>
    </svg>
)
